export default "__VITE_PUBLIC_ASSET__d7c30d7f__"